export enum TipoIndicador {
    Metricas = 'Histórico',
    Instantanea = 'Instantánea',
    Dashboard =  'Dashboard'
}